// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"17d0f8f6","726":"44a2d198","787":"b79eea6a"}[chunkId] + ".chunk.js";
};